import Associates from './AssociatesController';

export default Associates;
